import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./Contexts/auth.context";
// import 'bootstrap/dist/css/bootstrap.min.css';


import "react-datepicker/dist/react-datepicker.css";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { AppRoutes } from "./routing/app.routes";
import { ThemeProvider } from "styled-components";
import theme from "./theme/theme";
import GlobalStyle from "./theme/global.styles";
import { CatalogueProvider } from "./Contexts/catalogue.context";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "./components/Context/ContextComponent";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <PayPalScriptProvider
         options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
          // "buyer-country": "US", // Ensures Venmo appears only for US buyers
          // "enable-funding": "venmo", // Enables Venmo as a funding source
          // components: "buttons,funding-eligibility", // Adds funding eligibility check
          // "disable-funding": "paylater", // Disables Pay Later option
        }}
      >
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <AuthProvider>
            <Provider>
            <CatalogueProvider>
              <AppRoutes />
            </CatalogueProvider>
            </Provider>
          </AuthProvider>
        </ThemeProvider>
      </PayPalScriptProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if(process.env.REACT_APP_ENVIRONMENT === 'app') {
  const gtmScript = document.createElement('script');
  gtmScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-4E3GQHG8ST';
  gtmScript.async = true;
  document.body.appendChild(gtmScript);

  gtmScript.addEventListener('load', () => {
    if(window.dataLayer) {
      window.dataLayer = window.dataLayer || []; 
      function gtag(){window.dataLayer.push(arguments);} 
      gtag('js', new Date()); 
    }
  });
}